"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.adjustAuthLevel = exports.removeFromProject = exports.assignToProject = exports.createAndAssign = exports.deleteGroup = exports.createGroup = exports.groupsForProject = exports.getGroups = exports.GET_GROUPS = void 0;

var _auth = require("./auth");

var _users = require("./users");

var _avlComponents = require("@availabs/avl-components");

var _utils = require("./utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var GET_GROUPS = "AMS::GET_GROUPS";
exports.GET_GROUPS = GET_GROUPS;

var getGroups = function getGroups() {
  return function (dispatch, getState) {
    var token = getState().user.token;

    if (token) {
      return (0, _utils.postJson)("".concat(_utils.Config.AUTH_HOST, "/groups"), {
        token: token
      }).then(function (res) {
        if (res.error) {
          dispatch((0, _auth.auth)());
          dispatch((0, _avlComponents.sendSystemMessage)(res.error));
        } else {
          dispatch(_objectSpread({
            type: GET_GROUPS
          }, res));
        }
      });
    } else {
      return Promise.resolve();
    }
  };
};

exports.getGroups = getGroups;

var groupsForProject = function groupsForProject() {
  return function (dispatch, getState) {
    var token = getState().user.token;

    var _Config = (0, _utils.Config)(),
        AUTH_HOST = _Config.AUTH_HOST,
        PROJECT_NAME = _Config.PROJECT_NAME;

    if (token) {
      return (0, _utils.postJson)("".concat(AUTH_HOST, "/groups/byproject"), {
        token: token,
        project: PROJECT_NAME
      }).then(function (res) {
        if (res.error) {
          dispatch((0, _auth.auth)());
          dispatch((0, _avlComponents.sendSystemMessage)(res.error));
        } else {
          dispatch(_objectSpread({
            type: GET_GROUPS
          }, res));
        }
      });
    } else {
      return Promise.resolve();
    }
  };
};

exports.groupsForProject = groupsForProject;

var createGroup = function createGroup(name) {
  return function (dispatch, getState) {
    var token = getState().user.token;

    if (token) {
      return (0, _utils.postJson)("".concat(_utils.Config.AUTH_HOST, "/group/create"), {
        token: token,
        name: name
      }).then(function (res) {
        if (res.error) {
          dispatch((0, _auth.auth)());
          dispatch((0, _avlComponents.sendSystemMessage)(res.error));
        } else {
          dispatch(getGroups());

          if (res.message) {
            dispatch((0, _avlComponents.sendSystemMessage)(res.message));
          }
        }
      });
    } else {
      return Promise.resolve();
    }
  };
};

exports.createGroup = createGroup;

var deleteGroup = function deleteGroup(name) {
  return function (dispatch, getState) {
    var _getState$user = getState().user,
        token = _getState$user.token,
        groups = _getState$user.groups;

    if (token) {
      return (0, _utils.postJson)("".concat(_utils.Config.AUTH_HOST, "/group/delete"), {
        token: token,
        name: name
      }).then(function (res) {
        if (res.error) {
          dispatch((0, _auth.auth)());
          dispatch((0, _avlComponents.sendSystemMessage)(res.error));
        } else {
          if (groups.includes(name)) {
            dispatch((0, _auth.auth)());
          }

          dispatch((0, _users.getUsers)());
          dispatch(getGroups());

          if (res.message) {
            dispatch((0, _avlComponents.sendSystemMessage)(res.message));
          }
        }
      });
    } else {
      return Promise.resolve();
    }
  };
};

exports.deleteGroup = deleteGroup;

var createAndAssign = function createAndAssign(group_name, auth_level) {
  return function (dispatch, getState) {
    var token = getState().user.token;

    if (token) {
      return (0, _utils.postJson)("".concat(_utils.Config.AUTH_HOST, "/group/create/project/assign"), {
        token: token,
        group_name: group_name,
        project_name: _utils.Config.PROJECT_NAME,
        auth_level: auth_level
      }).then(function (res) {
        if (res.error) {
          dispatch((0, _auth.auth)());
          dispatch((0, _avlComponents.sendSystemMessage)(res.error));
        } else {
          dispatch(getGroups());

          if (res.message) {
            dispatch((0, _avlComponents.sendSystemMessage)(res.message));
          }
        }
      });
    } else {
      return Promise.resolve();
    }
  };
};

exports.createAndAssign = createAndAssign;

var assignToProject = function assignToProject(group_name, auth_level) {
  return function (dispatch, getState) {
    var _getState$user2 = getState().user,
        token = _getState$user2.token,
        groups = _getState$user2.groups;

    if (token) {
      return (0, _utils.postJson)("".concat(_utils.Config.AUTH_HOST, "/group/project/assign"), {
        token: token,
        group_name: group_name,
        project_name: _utils.Config.PROJECT_NAME,
        auth_level: auth_level
      }).then(function (res) {
        if (res.error) {
          dispatch((0, _auth.auth)());
          dispatch((0, _avlComponents.sendSystemMessage)(res.error));
        } else {
          if (groups.includes(group_name)) {
            dispatch((0, _auth.auth)());
          }

          dispatch(getGroups());

          if (res.message) {
            dispatch((0, _avlComponents.sendSystemMessage)(res.message));
          }
        }
      });
    } else {
      return Promise.resolve();
    }
  };
};

exports.assignToProject = assignToProject;

var removeFromProject = function removeFromProject(group_name) {
  return function (dispatch, getState) {
    var _getState$user3 = getState().user,
        token = _getState$user3.token,
        groups = _getState$user3.groups;

    if (token) {
      return (0, _utils.postJson)("".concat(_utils.Config.AUTH_HOST, "/group/project/remove"), {
        token: token,
        group_name: group_name,
        project_name: _utils.Config.PROJECT_NAME
      }).then(function (res) {
        if (res.error) {
          dispatch((0, _auth.auth)());
          dispatch((0, _avlComponents.sendSystemMessage)(res.error));
        } else {
          if (groups.includes(group_name)) {
            dispatch((0, _auth.auth)());
          }

          dispatch(getGroups());
          dispatch((0, _users.getUsers)());

          if (res.message) {
            dispatch((0, _avlComponents.sendSystemMessage)(res.message));
          }
        }
      });
    } else {
      return Promise.resolve();
    }
  };
};

exports.removeFromProject = removeFromProject;

var adjustAuthLevel = function adjustAuthLevel(group_name, auth_level) {
  return function (dispatch, getState) {
    var token = getState().user.token;

    if (token) {
      return (0, _utils.postJson)("".concat(_utils.Config.AUTH_HOST, "/group/project/adjust"), {
        token: token,
        group_name: group_name,
        project_name: _utils.Config.PROJECT_NAME,
        auth_level: auth_level
      }).then(function (res) {
        if (res.error) {
          dispatch((0, _auth.auth)());
          dispatch((0, _avlComponents.sendSystemMessage)(res.error));
        } else {
          dispatch(getGroups());

          if (res.message) {
            dispatch((0, _avlComponents.sendSystemMessage)(res.message));
          }
        }
      });
    } else {
      return Promise.resolve();
    }
  };
};

exports.adjustAuthLevel = adjustAuthLevel;